import { render, staticRenderFns } from "./payConfirm.vue?vue&type=template&id=2e34192b&scoped=true"
import script from "./payConfirm.vue?vue&type=script&lang=js"
export * from "./payConfirm.vue?vue&type=script&lang=js"
import style0 from "./payConfirm.vue?vue&type=style&index=0&id=2e34192b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34192b",
  null
  
)

export default component.exports